import { render, staticRenderFns } from "./PunchInGeolocation.vue?vue&type=template&id=3585ea2a"
import script from "./PunchInGeolocation.vue?vue&type=script&lang=js"
export * from "./PunchInGeolocation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports